export default __webpack_public_path__ + "static/media/31.d4be84e2.jpg";